import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { ZoomIn } from 'lucide-react';

const RestaurantGallery: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    {
      src: '/images/restaurant/full-dining-room.jpg',
      alt: 'Full Dining Room'
    },
    {
      src: '/images/restaurant/restaurant1.jpg',
      alt: 'Restaurant Interior'
    },
    {
      src: '/images/restaurant/restaurant2.jpg',
      alt: 'Restaurant Dining Area'
    },
    {
      src: '/images/restaurant/summer-dining.jpg',
      alt: 'Summer Dining'
    },
    {
      src: '/images/restaurant/steak-pie1.jpg',
      alt: 'Steak Pie'
    },
    {
      src: '/images/restaurant/lager.jpg',
      alt: 'Lager'
    },
    {
      src: '/images/restaurant/gift-voucher.jpg',
      alt: 'Gift Voucher'
    },
    {
      src: '/images/restaurant/open.jpg',
      alt: 'Open Sign'
    }
  ];

  const openLightbox = (index: number) => {
    setCurrentIndex(index);
    setOpen(true);
  };

  return (
    <div className="mt-12 mb-16">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {images.map((image, index) => (
          <div
            key={index}
            className="relative overflow-hidden rounded-lg cursor-pointer group aspect-video"
            onClick={() => openLightbox(index)}
          >
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-300 flex items-center justify-center">
              <ZoomIn className="w-12 h-12 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          </div>
        ))}
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={currentIndex}
        slides={images}
      />
    </div>
  );
};

export default RestaurantGallery;
